/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedUsersRouteImport } from './routes/_authenticated/users'
import { Route as AuthenticatedTemplatesRouteImport } from './routes/_authenticated/templates'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedRevenueRouteImport } from './routes/_authenticated/revenue'
import { Route as AuthenticatedRapidapiRouteImport } from './routes/_authenticated/rapidapi'
import { Route as AuthenticatedPlansRouteImport } from './routes/_authenticated/plans'
import { Route as AuthenticatedPackagesRouteImport } from './routes/_authenticated/packages'
import { Route as AuthenticatedOrganizationsRouteImport } from './routes/_authenticated/organizations'
import { Route as AuthenticatedLandingPagesRouteImport } from './routes/_authenticated/landing-pages'
import { Route as AuthenticatedKnowledgeBasesRouteImport } from './routes/_authenticated/knowledge-bases'
import { Route as AuthenticatedFeedbackRouteImport } from './routes/_authenticated/feedback'
import { Route as AuthenticatedEmailTemplatesRouteImport } from './routes/_authenticated/email-templates'
import { Route as AuthenticatedEmailCampaignsRouteImport } from './routes/_authenticated/email-campaigns'
import { Route as AuthenticatedDistributionModesRouteImport } from './routes/_authenticated/distribution-modes'
import { Route as AuthenticatedCreditCostsRouteImport } from './routes/_authenticated/credit-costs'
import { Route as AuthenticatedCouponsRouteImport } from './routes/_authenticated/coupons'
import { Route as AuthenticatedClientConfigRouteImport } from './routes/_authenticated/client-config'
import { Route as AuthenticatedBoostsRouteImport } from './routes/_authenticated/boosts'
import { Route as AuthenticatedBetaRequestsRouteImport } from './routes/_authenticated/beta-requests'
import { Route as AuthenticatedAuditRouteImport } from './routes/_authenticated/audit'
import { Route as AuthenticatedAnalyticsRouteImport } from './routes/_authenticated/analytics'
import { Route as AuthenticatedAddonsRouteImport } from './routes/_authenticated/addons'
import { Route as AuthenticatedUsersUserIdRouteImport } from './routes/_authenticated/users_.$userId'
import { Route as AuthenticatedOrganizationsOrgIdRouteImport } from './routes/_authenticated/organizations_.$orgId'
import { Route as AuthenticatedLandingPagesPageIdRouteImport } from './routes/_authenticated/landing-pages_.$pageId'
import { Route as AuthenticatedCouponsCreateRouteImport } from './routes/_authenticated/coupons_.create'
import { Route as AuthenticatedClientConfigUserIdRouteImport } from './routes/_authenticated/client-config_.$userId'
import { Route as AuthenticatedLandingPagesPageIdAnalyticsRouteImport } from './routes/_authenticated/landing-pages_.$pageId_.analytics'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUsersRoute = AuthenticatedUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTemplatesRoute = AuthenticatedTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRevenueRoute = AuthenticatedRevenueRouteImport.update({
  id: '/revenue',
  path: '/revenue',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRapidapiRoute = AuthenticatedRapidapiRouteImport.update({
  id: '/rapidapi',
  path: '/rapidapi',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPlansRoute = AuthenticatedPlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPackagesRoute = AuthenticatedPackagesRouteImport.update({
  id: '/packages',
  path: '/packages',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOrganizationsRoute =
  AuthenticatedOrganizationsRouteImport.update({
    id: '/organizations',
    path: '/organizations',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLandingPagesRoute =
  AuthenticatedLandingPagesRouteImport.update({
    id: '/landing-pages',
    path: '/landing-pages',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedKnowledgeBasesRoute =
  AuthenticatedKnowledgeBasesRouteImport.update({
    id: '/knowledge-bases',
    path: '/knowledge-bases',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFeedbackRoute = AuthenticatedFeedbackRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedEmailTemplatesRoute =
  AuthenticatedEmailTemplatesRouteImport.update({
    id: '/email-templates',
    path: '/email-templates',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEmailCampaignsRoute =
  AuthenticatedEmailCampaignsRouteImport.update({
    id: '/email-campaigns',
    path: '/email-campaigns',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDistributionModesRoute =
  AuthenticatedDistributionModesRouteImport.update({
    id: '/distribution-modes',
    path: '/distribution-modes',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCreditCostsRoute =
  AuthenticatedCreditCostsRouteImport.update({
    id: '/credit-costs',
    path: '/credit-costs',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCouponsRoute = AuthenticatedCouponsRouteImport.update({
  id: '/coupons',
  path: '/coupons',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedClientConfigRoute =
  AuthenticatedClientConfigRouteImport.update({
    id: '/client-config',
    path: '/client-config',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBoostsRoute = AuthenticatedBoostsRouteImport.update({
  id: '/boosts',
  path: '/boosts',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedBetaRequestsRoute =
  AuthenticatedBetaRequestsRouteImport.update({
    id: '/beta-requests',
    path: '/beta-requests',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAuditRoute = AuthenticatedAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAnalyticsRoute = AuthenticatedAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAddonsRoute = AuthenticatedAddonsRouteImport.update({
  id: '/addons',
  path: '/addons',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUsersUserIdRoute =
  AuthenticatedUsersUserIdRouteImport.update({
    id: '/users_/$userId',
    path: '/users/$userId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrganizationsOrgIdRoute =
  AuthenticatedOrganizationsOrgIdRouteImport.update({
    id: '/organizations_/$orgId',
    path: '/organizations/$orgId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLandingPagesPageIdRoute =
  AuthenticatedLandingPagesPageIdRouteImport.update({
    id: '/landing-pages_/$pageId',
    path: '/landing-pages/$pageId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCouponsCreateRoute =
  AuthenticatedCouponsCreateRouteImport.update({
    id: '/coupons_/create',
    path: '/coupons/create',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClientConfigUserIdRoute =
  AuthenticatedClientConfigUserIdRouteImport.update({
    id: '/client-config_/$userId',
    path: '/client-config/$userId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLandingPagesPageIdAnalyticsRoute =
  AuthenticatedLandingPagesPageIdAnalyticsRouteImport.update({
    id: '/landing-pages_/$pageId_/analytics',
    path: '/landing-pages/$pageId/analytics',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/login': typeof LoginRoute
  '/addons': typeof AuthenticatedAddonsRoute
  '/analytics': typeof AuthenticatedAnalyticsRoute
  '/audit': typeof AuthenticatedAuditRoute
  '/beta-requests': typeof AuthenticatedBetaRequestsRoute
  '/boosts': typeof AuthenticatedBoostsRoute
  '/client-config': typeof AuthenticatedClientConfigRoute
  '/coupons': typeof AuthenticatedCouponsRoute
  '/credit-costs': typeof AuthenticatedCreditCostsRoute
  '/distribution-modes': typeof AuthenticatedDistributionModesRoute
  '/email-campaigns': typeof AuthenticatedEmailCampaignsRoute
  '/email-templates': typeof AuthenticatedEmailTemplatesRoute
  '/feedback': typeof AuthenticatedFeedbackRoute
  '/knowledge-bases': typeof AuthenticatedKnowledgeBasesRoute
  '/landing-pages': typeof AuthenticatedLandingPagesRoute
  '/organizations': typeof AuthenticatedOrganizationsRoute
  '/packages': typeof AuthenticatedPackagesRoute
  '/plans': typeof AuthenticatedPlansRoute
  '/rapidapi': typeof AuthenticatedRapidapiRoute
  '/revenue': typeof AuthenticatedRevenueRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/templates': typeof AuthenticatedTemplatesRoute
  '/users': typeof AuthenticatedUsersRoute
  '/client-config/$userId': typeof AuthenticatedClientConfigUserIdRoute
  '/coupons/create': typeof AuthenticatedCouponsCreateRoute
  '/landing-pages/$pageId': typeof AuthenticatedLandingPagesPageIdRoute
  '/organizations/$orgId': typeof AuthenticatedOrganizationsOrgIdRoute
  '/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/landing-pages/$pageId/analytics': typeof AuthenticatedLandingPagesPageIdAnalyticsRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/addons': typeof AuthenticatedAddonsRoute
  '/analytics': typeof AuthenticatedAnalyticsRoute
  '/audit': typeof AuthenticatedAuditRoute
  '/beta-requests': typeof AuthenticatedBetaRequestsRoute
  '/boosts': typeof AuthenticatedBoostsRoute
  '/client-config': typeof AuthenticatedClientConfigRoute
  '/coupons': typeof AuthenticatedCouponsRoute
  '/credit-costs': typeof AuthenticatedCreditCostsRoute
  '/distribution-modes': typeof AuthenticatedDistributionModesRoute
  '/email-campaigns': typeof AuthenticatedEmailCampaignsRoute
  '/email-templates': typeof AuthenticatedEmailTemplatesRoute
  '/feedback': typeof AuthenticatedFeedbackRoute
  '/knowledge-bases': typeof AuthenticatedKnowledgeBasesRoute
  '/landing-pages': typeof AuthenticatedLandingPagesRoute
  '/organizations': typeof AuthenticatedOrganizationsRoute
  '/packages': typeof AuthenticatedPackagesRoute
  '/plans': typeof AuthenticatedPlansRoute
  '/rapidapi': typeof AuthenticatedRapidapiRoute
  '/revenue': typeof AuthenticatedRevenueRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/templates': typeof AuthenticatedTemplatesRoute
  '/users': typeof AuthenticatedUsersRoute
  '/': typeof AuthenticatedIndexRoute
  '/client-config/$userId': typeof AuthenticatedClientConfigUserIdRoute
  '/coupons/create': typeof AuthenticatedCouponsCreateRoute
  '/landing-pages/$pageId': typeof AuthenticatedLandingPagesPageIdRoute
  '/organizations/$orgId': typeof AuthenticatedOrganizationsOrgIdRoute
  '/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/landing-pages/$pageId/analytics': typeof AuthenticatedLandingPagesPageIdAnalyticsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authenticated/addons': typeof AuthenticatedAddonsRoute
  '/_authenticated/analytics': typeof AuthenticatedAnalyticsRoute
  '/_authenticated/audit': typeof AuthenticatedAuditRoute
  '/_authenticated/beta-requests': typeof AuthenticatedBetaRequestsRoute
  '/_authenticated/boosts': typeof AuthenticatedBoostsRoute
  '/_authenticated/client-config': typeof AuthenticatedClientConfigRoute
  '/_authenticated/coupons': typeof AuthenticatedCouponsRoute
  '/_authenticated/credit-costs': typeof AuthenticatedCreditCostsRoute
  '/_authenticated/distribution-modes': typeof AuthenticatedDistributionModesRoute
  '/_authenticated/email-campaigns': typeof AuthenticatedEmailCampaignsRoute
  '/_authenticated/email-templates': typeof AuthenticatedEmailTemplatesRoute
  '/_authenticated/feedback': typeof AuthenticatedFeedbackRoute
  '/_authenticated/knowledge-bases': typeof AuthenticatedKnowledgeBasesRoute
  '/_authenticated/landing-pages': typeof AuthenticatedLandingPagesRoute
  '/_authenticated/organizations': typeof AuthenticatedOrganizationsRoute
  '/_authenticated/packages': typeof AuthenticatedPackagesRoute
  '/_authenticated/plans': typeof AuthenticatedPlansRoute
  '/_authenticated/rapidapi': typeof AuthenticatedRapidapiRoute
  '/_authenticated/revenue': typeof AuthenticatedRevenueRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_authenticated/templates': typeof AuthenticatedTemplatesRoute
  '/_authenticated/users': typeof AuthenticatedUsersRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/client-config_/$userId': typeof AuthenticatedClientConfigUserIdRoute
  '/_authenticated/coupons_/create': typeof AuthenticatedCouponsCreateRoute
  '/_authenticated/landing-pages_/$pageId': typeof AuthenticatedLandingPagesPageIdRoute
  '/_authenticated/organizations_/$orgId': typeof AuthenticatedOrganizationsOrgIdRoute
  '/_authenticated/users_/$userId': typeof AuthenticatedUsersUserIdRoute
  '/_authenticated/landing-pages_/$pageId_/analytics': typeof AuthenticatedLandingPagesPageIdAnalyticsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/addons'
    | '/analytics'
    | '/audit'
    | '/beta-requests'
    | '/boosts'
    | '/client-config'
    | '/coupons'
    | '/credit-costs'
    | '/distribution-modes'
    | '/email-campaigns'
    | '/email-templates'
    | '/feedback'
    | '/knowledge-bases'
    | '/landing-pages'
    | '/organizations'
    | '/packages'
    | '/plans'
    | '/rapidapi'
    | '/revenue'
    | '/settings'
    | '/templates'
    | '/users'
    | '/client-config/$userId'
    | '/coupons/create'
    | '/landing-pages/$pageId'
    | '/organizations/$orgId'
    | '/users/$userId'
    | '/landing-pages/$pageId/analytics'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/addons'
    | '/analytics'
    | '/audit'
    | '/beta-requests'
    | '/boosts'
    | '/client-config'
    | '/coupons'
    | '/credit-costs'
    | '/distribution-modes'
    | '/email-campaigns'
    | '/email-templates'
    | '/feedback'
    | '/knowledge-bases'
    | '/landing-pages'
    | '/organizations'
    | '/packages'
    | '/plans'
    | '/rapidapi'
    | '/revenue'
    | '/settings'
    | '/templates'
    | '/users'
    | '/'
    | '/client-config/$userId'
    | '/coupons/create'
    | '/landing-pages/$pageId'
    | '/organizations/$orgId'
    | '/users/$userId'
    | '/landing-pages/$pageId/analytics'
  id:
    | '__root__'
    | '/_authenticated'
    | '/login'
    | '/_authenticated/addons'
    | '/_authenticated/analytics'
    | '/_authenticated/audit'
    | '/_authenticated/beta-requests'
    | '/_authenticated/boosts'
    | '/_authenticated/client-config'
    | '/_authenticated/coupons'
    | '/_authenticated/credit-costs'
    | '/_authenticated/distribution-modes'
    | '/_authenticated/email-campaigns'
    | '/_authenticated/email-templates'
    | '/_authenticated/feedback'
    | '/_authenticated/knowledge-bases'
    | '/_authenticated/landing-pages'
    | '/_authenticated/organizations'
    | '/_authenticated/packages'
    | '/_authenticated/plans'
    | '/_authenticated/rapidapi'
    | '/_authenticated/revenue'
    | '/_authenticated/settings'
    | '/_authenticated/templates'
    | '/_authenticated/users'
    | '/_authenticated/'
    | '/_authenticated/client-config_/$userId'
    | '/_authenticated/coupons_/create'
    | '/_authenticated/landing-pages_/$pageId'
    | '/_authenticated/organizations_/$orgId'
    | '/_authenticated/users_/$userId'
    | '/_authenticated/landing-pages_/$pageId_/analytics'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users': {
      id: '/_authenticated/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthenticatedUsersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/templates': {
      id: '/_authenticated/templates'
      path: '/templates'
      fullPath: '/templates'
      preLoaderRoute: typeof AuthenticatedTemplatesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/revenue': {
      id: '/_authenticated/revenue'
      path: '/revenue'
      fullPath: '/revenue'
      preLoaderRoute: typeof AuthenticatedRevenueRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/rapidapi': {
      id: '/_authenticated/rapidapi'
      path: '/rapidapi'
      fullPath: '/rapidapi'
      preLoaderRoute: typeof AuthenticatedRapidapiRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/plans': {
      id: '/_authenticated/plans'
      path: '/plans'
      fullPath: '/plans'
      preLoaderRoute: typeof AuthenticatedPlansRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/packages': {
      id: '/_authenticated/packages'
      path: '/packages'
      fullPath: '/packages'
      preLoaderRoute: typeof AuthenticatedPackagesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/organizations': {
      id: '/_authenticated/organizations'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof AuthenticatedOrganizationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/landing-pages': {
      id: '/_authenticated/landing-pages'
      path: '/landing-pages'
      fullPath: '/landing-pages'
      preLoaderRoute: typeof AuthenticatedLandingPagesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/knowledge-bases': {
      id: '/_authenticated/knowledge-bases'
      path: '/knowledge-bases'
      fullPath: '/knowledge-bases'
      preLoaderRoute: typeof AuthenticatedKnowledgeBasesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/feedback': {
      id: '/_authenticated/feedback'
      path: '/feedback'
      fullPath: '/feedback'
      preLoaderRoute: typeof AuthenticatedFeedbackRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/email-templates': {
      id: '/_authenticated/email-templates'
      path: '/email-templates'
      fullPath: '/email-templates'
      preLoaderRoute: typeof AuthenticatedEmailTemplatesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/email-campaigns': {
      id: '/_authenticated/email-campaigns'
      path: '/email-campaigns'
      fullPath: '/email-campaigns'
      preLoaderRoute: typeof AuthenticatedEmailCampaignsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/distribution-modes': {
      id: '/_authenticated/distribution-modes'
      path: '/distribution-modes'
      fullPath: '/distribution-modes'
      preLoaderRoute: typeof AuthenticatedDistributionModesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/credit-costs': {
      id: '/_authenticated/credit-costs'
      path: '/credit-costs'
      fullPath: '/credit-costs'
      preLoaderRoute: typeof AuthenticatedCreditCostsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/coupons': {
      id: '/_authenticated/coupons'
      path: '/coupons'
      fullPath: '/coupons'
      preLoaderRoute: typeof AuthenticatedCouponsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/client-config': {
      id: '/_authenticated/client-config'
      path: '/client-config'
      fullPath: '/client-config'
      preLoaderRoute: typeof AuthenticatedClientConfigRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/boosts': {
      id: '/_authenticated/boosts'
      path: '/boosts'
      fullPath: '/boosts'
      preLoaderRoute: typeof AuthenticatedBoostsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/beta-requests': {
      id: '/_authenticated/beta-requests'
      path: '/beta-requests'
      fullPath: '/beta-requests'
      preLoaderRoute: typeof AuthenticatedBetaRequestsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/audit': {
      id: '/_authenticated/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuthenticatedAuditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/analytics': {
      id: '/_authenticated/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AuthenticatedAnalyticsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/addons': {
      id: '/_authenticated/addons'
      path: '/addons'
      fullPath: '/addons'
      preLoaderRoute: typeof AuthenticatedAddonsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users_/$userId': {
      id: '/_authenticated/users_/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof AuthenticatedUsersUserIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/organizations_/$orgId': {
      id: '/_authenticated/organizations_/$orgId'
      path: '/organizations/$orgId'
      fullPath: '/organizations/$orgId'
      preLoaderRoute: typeof AuthenticatedOrganizationsOrgIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/landing-pages_/$pageId': {
      id: '/_authenticated/landing-pages_/$pageId'
      path: '/landing-pages/$pageId'
      fullPath: '/landing-pages/$pageId'
      preLoaderRoute: typeof AuthenticatedLandingPagesPageIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/coupons_/create': {
      id: '/_authenticated/coupons_/create'
      path: '/coupons/create'
      fullPath: '/coupons/create'
      preLoaderRoute: typeof AuthenticatedCouponsCreateRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/client-config_/$userId': {
      id: '/_authenticated/client-config_/$userId'
      path: '/client-config/$userId'
      fullPath: '/client-config/$userId'
      preLoaderRoute: typeof AuthenticatedClientConfigUserIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/landing-pages_/$pageId_/analytics': {
      id: '/_authenticated/landing-pages_/$pageId_/analytics'
      path: '/landing-pages/$pageId/analytics'
      fullPath: '/landing-pages/$pageId/analytics'
      preLoaderRoute: typeof AuthenticatedLandingPagesPageIdAnalyticsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedAddonsRoute: typeof AuthenticatedAddonsRoute
  AuthenticatedAnalyticsRoute: typeof AuthenticatedAnalyticsRoute
  AuthenticatedAuditRoute: typeof AuthenticatedAuditRoute
  AuthenticatedBetaRequestsRoute: typeof AuthenticatedBetaRequestsRoute
  AuthenticatedBoostsRoute: typeof AuthenticatedBoostsRoute
  AuthenticatedClientConfigRoute: typeof AuthenticatedClientConfigRoute
  AuthenticatedCouponsRoute: typeof AuthenticatedCouponsRoute
  AuthenticatedCreditCostsRoute: typeof AuthenticatedCreditCostsRoute
  AuthenticatedDistributionModesRoute: typeof AuthenticatedDistributionModesRoute
  AuthenticatedEmailCampaignsRoute: typeof AuthenticatedEmailCampaignsRoute
  AuthenticatedEmailTemplatesRoute: typeof AuthenticatedEmailTemplatesRoute
  AuthenticatedFeedbackRoute: typeof AuthenticatedFeedbackRoute
  AuthenticatedKnowledgeBasesRoute: typeof AuthenticatedKnowledgeBasesRoute
  AuthenticatedLandingPagesRoute: typeof AuthenticatedLandingPagesRoute
  AuthenticatedOrganizationsRoute: typeof AuthenticatedOrganizationsRoute
  AuthenticatedPackagesRoute: typeof AuthenticatedPackagesRoute
  AuthenticatedPlansRoute: typeof AuthenticatedPlansRoute
  AuthenticatedRapidapiRoute: typeof AuthenticatedRapidapiRoute
  AuthenticatedRevenueRoute: typeof AuthenticatedRevenueRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedTemplatesRoute: typeof AuthenticatedTemplatesRoute
  AuthenticatedUsersRoute: typeof AuthenticatedUsersRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedClientConfigUserIdRoute: typeof AuthenticatedClientConfigUserIdRoute
  AuthenticatedCouponsCreateRoute: typeof AuthenticatedCouponsCreateRoute
  AuthenticatedLandingPagesPageIdRoute: typeof AuthenticatedLandingPagesPageIdRoute
  AuthenticatedOrganizationsOrgIdRoute: typeof AuthenticatedOrganizationsOrgIdRoute
  AuthenticatedUsersUserIdRoute: typeof AuthenticatedUsersUserIdRoute
  AuthenticatedLandingPagesPageIdAnalyticsRoute: typeof AuthenticatedLandingPagesPageIdAnalyticsRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAddonsRoute: AuthenticatedAddonsRoute,
  AuthenticatedAnalyticsRoute: AuthenticatedAnalyticsRoute,
  AuthenticatedAuditRoute: AuthenticatedAuditRoute,
  AuthenticatedBetaRequestsRoute: AuthenticatedBetaRequestsRoute,
  AuthenticatedBoostsRoute: AuthenticatedBoostsRoute,
  AuthenticatedClientConfigRoute: AuthenticatedClientConfigRoute,
  AuthenticatedCouponsRoute: AuthenticatedCouponsRoute,
  AuthenticatedCreditCostsRoute: AuthenticatedCreditCostsRoute,
  AuthenticatedDistributionModesRoute: AuthenticatedDistributionModesRoute,
  AuthenticatedEmailCampaignsRoute: AuthenticatedEmailCampaignsRoute,
  AuthenticatedEmailTemplatesRoute: AuthenticatedEmailTemplatesRoute,
  AuthenticatedFeedbackRoute: AuthenticatedFeedbackRoute,
  AuthenticatedKnowledgeBasesRoute: AuthenticatedKnowledgeBasesRoute,
  AuthenticatedLandingPagesRoute: AuthenticatedLandingPagesRoute,
  AuthenticatedOrganizationsRoute: AuthenticatedOrganizationsRoute,
  AuthenticatedPackagesRoute: AuthenticatedPackagesRoute,
  AuthenticatedPlansRoute: AuthenticatedPlansRoute,
  AuthenticatedRapidapiRoute: AuthenticatedRapidapiRoute,
  AuthenticatedRevenueRoute: AuthenticatedRevenueRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedTemplatesRoute: AuthenticatedTemplatesRoute,
  AuthenticatedUsersRoute: AuthenticatedUsersRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedClientConfigUserIdRoute: AuthenticatedClientConfigUserIdRoute,
  AuthenticatedCouponsCreateRoute: AuthenticatedCouponsCreateRoute,
  AuthenticatedLandingPagesPageIdRoute: AuthenticatedLandingPagesPageIdRoute,
  AuthenticatedOrganizationsOrgIdRoute: AuthenticatedOrganizationsOrgIdRoute,
  AuthenticatedUsersUserIdRoute: AuthenticatedUsersUserIdRoute,
  AuthenticatedLandingPagesPageIdAnalyticsRoute:
    AuthenticatedLandingPagesPageIdAnalyticsRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
